import Joi from "joi";
import { VAR_LIMIT } from "../config/constant";

let minDate = new Date();
minDate = minDate.setFullYear(minDate.getFullYear() - VAR_LIMIT.age.max);

export const updateUserProfileValidator = (data) => {
  const schema = Joi.object({
    name: Joi.string().required().messages({
      "string.empty": `"nama" tidak boleh kosong`,
    }),
    workingPlace: Joi.string().required().messages({
      "string.empty": `"Tempat praktek" tidak boleh kosong`,
    }),
    strNumber: Joi.string().required().messages({
      "string.empty": `"Nomor STR" tidak boleh kosong`,
    }),
    description: Joi.string().required().allow(null).allow(""),
  });
  return schema.validate(data);
};

export const updatePasswordValidator = (data) => {
  const schema = Joi.object({
    password: Joi.string().required().messages({
      "string.empty": `"Password" tidak boleh kosong`,
    }),
    newPassword: Joi.string().min(6).required().messages({
      "string.empty": `"Password baru" tidak boleh kosong`,
      "string.min": "Gunakan password yang lebih kuat",
    }),
    passwordConfirmation: Joi.string().valid(data.newPassword).messages({
      "any.only": `"Konfirmasi password" tidak cocok`,
    }),
  });
  return schema.validate(data);
};

export const updateUserDataValidator = (data) => {
  const schema = Joi.object({
    isMale: Joi.boolean().required(),
    dateOfBirth: Joi.date().min(minDate).max(Date.now()).messages({
      "date.base": "Format tanggal tidak valid",
      "date.min": "Tanggal lahir tidak valid",
      "date.max": "Tanggal lahir tidak valid",
    }),
    weight: Joi.number()
      .min(VAR_LIMIT.weight.min)
      .max(VAR_LIMIT.weight.max)
      .required()
      .messages({
        "any.required": `"Berat badan" tidak boleh kosong`,
        "number.base": `"Berat badan" harus berupa bilangan`,
        "number.max": `"Berat badan" tidak valid`,
        "number.min": `"Berat badan" tidak valid`,
      }),
    height: Joi.number()
      .min(VAR_LIMIT.height.min)
      .max(VAR_LIMIT.height.max)
      .required()
      .messages({
        "any.required": `"Tinggi badan" tidak boleh kosong`,
        "number.base": `"Berat badan" harus berupa bilangan`,
        "number.max": `"Tinggi badan" tidak valid`,
        "number.min": `"Tinggi badan" tidak valid`,
      }),
  });
  return schema.validate(data);
};

export const resetPasswordValidator = (data) => {
  const schema = Joi.object({
    password: Joi.string().min(6).required().messages({
      "string.empty": `"Password baru" tidak boleh kosong`,
      "string.min": "Gunakan password yang lebih kuat",
    }),
  });
  return schema.validate(data);
};
